import { NavLink } from "react-router-dom"

// import AdminLinkIcon from 'images/admin-link-icon.svg'
// import AdminAuditIcon from 'images/admin-audit-icon.svg'
// import AdminUsersIcon from 'images/admin-users-icon.svg'
// import AdminBrowseIcon from 'images/admin-browse-icon.svg'
import AdminDeleteIcon from 'images/x-red.svg'
import AdminCompletedIcon from 'images/check-white.svg'
import { AdminList, AdminListItem } from 'admin/AdminViewListStyles'

import css from './sass/adminpage.module.scss'

import AdminAuctionsIcon from './images/admin-live-auction-icon.svg'
import AdminPreviewAuctionsIcon from './images/admin-auctions-icon.svg'

const AdminViewList = (props) => {

  const isUserSR = localStorage.getItem('isSolicitationReviewAdmin')
  const isUserAdmin = localStorage.getItem('isAuctionAdmin')

  console.log('is sr', isUserSR)

  return (
    <AdminList >
      <ul>
{/*         <hr />
       <div className={"divider"}>
          Shared Admin Tools
        </div>
        <hr />

        <AdminListItem>
          <NavLink className="bold" id="AdminLinkUserToCrmLink" activeClassName="selectedTab" to="/admin/linkusertocrm">
            <img src={AdminLinkIcon} alt='Link Donor icon'/>
            <div><span>LINK USER TO CRM</span></div>
          </NavLink>
        </AdminListItem>
        <AdminListItem>
          <NavLink className="bold" id="AdminAuditLink"  activeClassName="selectedTab" to="/admin/history">
            <img className="admin-users-svg" src={AdminAuditIcon} alt='Admin Change History icon'/>
            <div><span>CHANGE HISTORY</span></div>
          </NavLink>
        </AdminListItem>
        <AdminListItem>
          <NavLink className="bold" id="AdminUsersLink"  activeClassName="selectedTab" to="/admin/users">
            <img src={AdminUsersIcon} alt='Admin Users icon'/>
            <div><span>USERS</span></div>
          </NavLink>
        </AdminListItem>

        <div className={"divider"}>
          Auctions Admin
        </div>
   */}     <hr />

        <AdminListItem>
          <NavLink className="bold" id="AdminPreviewAuctionLink" activeClassName="selectedTab" to="/admin/listpreviewauctions">
          <img  src={AdminPreviewAuctionsIcon} alt='Preview Auctions Menu'/>
          <div><span className={css['admin-white-text']}>PREVIEW AUCTIONS</span></div>
          </NavLink>
        </AdminListItem>
        {!isUserSR && <>
          <AdminListItem>
            <NavLink className="bold"  id="AdminPublicAuctionsLink"  activeClassName="selectedTab" to="/admin/listpublicauctions">
              <img  src={AdminAuctionsIcon} alt='Public Auctions Menu'/>
              <div><span className={css['admin-white-text']}>PUBLIC AUCTIONS</span></div>
            </NavLink>
          </AdminListItem>
          {isUserAdmin &&<AdminListItem>
            <NavLink className="bold" id="AdminArchivedAuctionsLink" activeClassName="selectedTab" to="/admin/listarchivedauctions">
              <img  src={AdminCompletedIcon} alt='Archived Auctions Menu'/>
              <div><span className={css['admin-white-text']}>ARCHIVED AUCTIONS</span></div>
            </NavLink>
          </AdminListItem>}

          {localStorage.isAuctionSuperAdmin &&
            <AdminListItem>
              <NavLink className="bold"  id="AdminDeleteUserLink"  activeClassName="selectedTab" to="/admin/deleteauctionuser">
                <img src={AdminDeleteIcon} alt='Delete User icon' id="delete-icon"/>
                <div><span className={css['admin-white-text']}>DELETE AUCTION USER</span></div>
              </NavLink>
            </AdminListItem>}
        </>}
      </ul>
    </AdminList>
  )
}

export default AdminViewList
